// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"362aacbc","879":"8a1a503d"}[chunkId] + ".chunk.css";
};